<!-- PMMS Logo  -->
<div class="container" *ngIf="!isWhittier">
  <div class="row">
    <div class="col-md-12" >
      <img src="assets/pmms-logo-only-128x128.png" width="37" height="37" style="margin-left: -8px">
      <span class="pmms-logo-text">Pacific Medical Management Services, Inc.</span>
    </div>
  </div>
</div>
<!-- End: PMMS Logo  -->

<!-- WMMA Logo  -->
<div class="container" *ngIf="isWhittier">
  <div class="row">
    <div class="col-md-12" >
      <img src="/assets/wmma-logo-only-h128.png" height="35" style="margin-left: -5px">
      <span class="pmms-logo-text"> Whittier Medical Management Associates, Inc.</span>
    </div>
  </div>
</div>
<!-- End: WMMA Logo  -->

<!-- Navbar -->
<nav class="navbar navbar-expand-lg navbar-dark bg-dark">
  <div class="container">
    <a class="navbar-brand" routerLink="/">DX Search App</a>
    <button class="navbar-toggler" type="button" (click)="isNavbarCollapsed = !isNavbarCollapsed" data-toggle="collapse" data-target="#navbarsExample07" aria-controls="navbarsExample07" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" [ngbCollapse]="isNavbarCollapsed" id="navbarSupportedContent" *ngIf="authService.isLoggedIn()">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
          <a class="nav-link" [routerLink]="['/']" (click)="isNavbarCollapsed = true">Dx10&nbsp;&nbsp;<span class="sr-only">(current)</span></a>
        </li>
        <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
          <a class="nav-link" [routerLink]="['/search9']" (click)="isNavbarCollapsed = true">Dx9</a>
        </li>
      </ul>
    </div>

    <!-- <div class="collapse navbar-collapse" [ngbCollapse]="isNavbarCollapsed" *ngIf="authService.isLoggedIn()">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <div class="col text-end">
            <a class="nav-link" (click)="isNavbarCollapsed = true; logout()">Logout</a>
          </div>
          </li>
        </ul>
    </div> -->

    <div class="row ms-auto" *ngIf="authService.isLoggedIn()">
      <ul class="navbar-nav ml-auto">
        <li class="nav-item">
          <div class="col text-end">
          <a class="nav-link" (click)="isNavbarCollapsed = true; logout()">Logout</a>
        </div>
        </li>
      </ul>
    </div>

  </div>

</nav>
